module.exports = __webpack_public_path__ + "static/media/map.d80d9c06.jpg";